import * as actions from 'store/getCare/connectCare/actions';
import { AnyAction } from 'redux';
import { normalizeProviders } from './mappers';

export interface ConnectCareState {
  paymentComplete: boolean;
  hasAcceptedConnectCareTC: boolean;
  connectCareTermsAndConditions?: string;
  isFetching: boolean;
  error: null | any;
}

export const defaultState: ConnectCareState = {
  paymentComplete: true,
  hasAcceptedConnectCareTC: false,
  connectCareTermsAndConditions: undefined,
  isFetching: false,
  error: null
};

const connectCareReducer = (state: ConnectCareState = defaultState, action: AnyAction) => {
  switch (action.type) {
    case actions.GET_PROVIDERS:
      return {
        ...state,
        isFetching: true,
        error: undefined
      };
    case actions.GET_PROVIDERS_SUCCESS:
      return {
        ...state,
        allProviders: normalizeProviders(action.payload.data),
        isFetching: false
      };
    case actions.GET_PROVIDERS_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case actions.GET_FORM_INFO:
      return {
        ...state,
        isFetching: true,
        error: undefined
      };
    case actions.GET_FORM_INFO_SUCCESS:
      return {
        ...state,
        formInfo: action.payload.data,
        isFetching: false
      };
    case actions.GET_FORM_INFO_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case actions.SELECT_PROVIDER:
      return {
        ...state,
        selectedProvider: action.payload
      };
    case actions.SET_ACCEPT_CONNECT_CARE_TC:
      return {
        ...state,
        hasAcceptedConnectCareTC: true
      };
    case actions.UPDATE_FORM_INFO:
      return {
        ...state,
        formInfo: action.payload
      };

    case actions.GET_CONNECT_CARE_TERMS_AND_CONDITIONS:
      return {
        ...state,
        isFetching: true,
        error: undefined
      };
    case actions.GET_CONNECT_CARE_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        connectCareTermsAndConditions: action.payload.data,
        isFetching: false
      };
    case actions.GET_CONNECT_CARE_TERMS_AND_CONDITIONS_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default connectCareReducer;
